// IMPORT REACT
import React from 'react';
import { Link } from 'react-router-dom';

// IMPORT COMPONENTS
import YAIcon from '../Icon';

// IMPORT STYLES
import {
  SC_Dropdown, 
	SC_DropdownToggle,
	SC_DropdownMenu,
	SC_DropdownItem,
} from './styles';

class YADropdown extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleMouseEvent = this.handleMouseEvent.bind(this);
    this.handleBlurEvent = this.handleBlurEvent.bind(this);
    this.hasFocus = this.hasFocus.bind(this);

    this.state = {
      show: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    // handles mouse events like click and dblclick
    document.addEventListener('mouseup', this.handleMouseEvent);
    // handles tabbing out of
    if (!this.dropdown){
      return false;
    }
    this.dropdown.addEventListener('focusout', this.handleBlurEvent);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  hasFocus(target) {
    // React ref callbacks pass `null` when a component unmounts, so guard against `this.dropdown` not existing
    if (!this.dropdown) {
      return false;
    }
    let dropdownHasFocus = false;
    let nodeIterator = document.createNodeIterator(this.dropdown, NodeFilter.SHOW_ELEMENT, null, false);
    let node;    
    
    while(node = nodeIterator.nextNode()) {
      if (node === target) {
        dropdownHasFocus = true;
        break;
      }
    }
    
    return dropdownHasFocus;
  }
  
  handleBlurEvent(e) {
    let dropdownHasFocus = this.hasFocus(e.relatedTarget);
    
    if (!dropdownHasFocus && this._isMounted) {
      this.setState({
        show: false
      });
    }    
  }
  
  handleMouseEvent(e) {
    let dropdownHasFocus = this.hasFocus(e.target);
    
    if (!dropdownHasFocus && this._isMounted) {
      this.setState({
        show: false
      });
    }
  }

  toggleDropdown() {
    this.setState({
      show: !this.state.show
    });
  }
  
  render() {
    let dropdownShow = this.state.show;

    return (
      <SC_Dropdown 
        className={dropdownShow ? 'show' : null}
        ref={(dropdown) => this.dropdown = dropdown}
      >
        <SC_DropdownToggle 
          aria-expanded={dropdownShow} 
          onClick={(e) => {
            e.preventDefault();
            this.toggleDropdown();
          }}
        >
          {this.props.toggleText}
        </SC_DropdownToggle>
        <SC_DropdownMenu 
          className={dropdownShow ? 'show' : null}  
        >
          <DropdownItems items={this.props.items} />
        </SC_DropdownMenu>
      </SC_Dropdown>
    );
  }
}
	
const DropdownItems = ({ items }) => {
  return (
    items.map((item, index) => {
      return (
        <SC_DropdownItem key={index} href={item.href} target="_blank">
          <YAIcon icon={item.icon} fill="black" height="40px" />
          {item.text}
        </SC_DropdownItem>
      )
    })
  );
}

export default YADropdown;